import { isSupportedType } from 'lib/VideoSupport';
import _ from 'lodash';
import Button from 'components/ButtonDeprecated';
import cx from 'classnames';
import Glyph from 'components/Glyph';
import MediaPlayer from 'components/MediaPlayer';
import { MediaPlayer as MediaPlayerType } from 'components/MediaPlayer';
import * as React from 'react';

import './styles/Video.scss';

/**
 * ## [MediaPlayer](/internal/components/MediaPlayer) for video files.
 *
 *
 * # Implementation
 *
 * Use `Video.isSupportedType(type)` to check whether the video file can be played in the user’s
 * browser.
 *
 *
 * ```example
 * <Video src="https://www.remind.com/assets/video/how-does-remind-work.mp4" />
 * ```
 */

type Props = {
  src: string;
};

type State = {
  id: string;
  showControl: boolean;
  started: boolean;
};

class Video extends React.Component<Props, State> {
  static isSupportedType = isSupportedType;
  state = {
    id: _.uniqueId(),
    showControl: false,
    started: false,
  };
  player!: MediaPlayerType;
  handleClick = () => {
    if (!this.state.started) {
      this.setState({ started: true });
    }
    const { player } = this;
    if (player.state.playing) {
      player.pause();
    } else {
      player.play();
    }
  };
  handleMouseEnter = () => {
    this.setState({ showControl: true });
  };
  handleMouseLeave = () => {
    const { player } = this;
    if (!player.state.playing) {
      return;
    }
    this.setState({ showControl: false });
  };
  render() {
    const { src } = this.props;
    const { id, showControl, started } = this.state;
    let play;
    if (!started) {
      play = (
        <Button
          color="whiteout"
          className="Video-playButton"
          eventElementName="Video-playButton"
          onClick={this.handleClick}
          aria-label="Play">
          <Glyph color="mascot" name="play" size="xlarge" solo />
        </Button>
      );
    }
    return (
      <div
        className="Video"
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}>
        <video id={id} src={src} onClick={this.handleClick} />
        {play}
        <MediaPlayer
          fullscreen
          playerId={id}
          reference={(p: MediaPlayerType) => {
            this.player = p;
          }}
          src={src}
          theme="dark"
          className={cx({
            'Video-controls': true,
            'Video-controls--hidden': !started || !showControl,
          })}
        />
      </div>
    );
  }
}
export default Video;
